import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

import { SearchParams } from '@/domain/app';
import { getDebitAccount } from '@/react-query/services/account';

import { Card, DebitAccount } from '@generated-types';
import useQueryParam from '@hooks/use-query-param';

export const useAccountFromAccountId = (card?: Card) => {
    return useQuery<DebitAccount>({
        queryKey: ['debit-account', card],
        queryFn: () => getDebitAccount(card!.accountId!),
        enabled: !!card && card.type !== 'CREDIT',
    });
};

export const useAccount = useAccountFromAccountId;

export const useAccountNumberFromQueryParam = () => {
    const accountNumber = useQueryParam(SearchParams.ACCOUNT_NUMBER);

    if (typeof accountNumber !== 'string' || accountNumber.length === 0) {
        return null;
    }

    return accountNumber;
};

export const useAccountIdFromQueryParam = () => {
    const [searchParams] = useSearchParams();
    const accountId = searchParams.get('kontoid');

    if (typeof accountId !== 'string' || accountId.length === 0) {
        return undefined;
    }

    return accountId;
};

export const useAccountFromQueryParam = () => {
    const accountId = useAccountIdFromQueryParam();
    return useQuery<DebitAccount>({
        queryKey: ['debitAccount', accountId],
        queryFn: () => getDebitAccount(accountId!),
        enabled: !!accountId,
    });
};
